import React from 'react';
import './ProspectStats360Tab.scss';
import ProspectStats360TabGeneralView
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectStats360Tab/components/ProspectStats360TabGeneralView/ProspectStats360TabGeneralView";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";

export default function ProspectStats360Tab() {
    const {currentRoute} = useNavigation();
    const isProductView = currentRoute?.routeType === 'PRODUCT_VIEW';

    return <ProspectStats360TabGeneralView isProductView={isProductView}/>
}
